import styled, { css } from 'styled-components';
import { IslandSectionContainer } from './IslandSectionContainer';

// IslandBody can have 3 overflow / grow states
// 1) Default - it grows endlessly following it's content
// 2) isScrollable - it grows up to 100% then it becomes scrollable;
//    - eg if you want to make island scrollable like a modal
// 3) preventScroll - it grows up to 100% then it hides the content below that
//    - eg if you want to have table with fixed header inside
//
// TODO: Consider better component API setup to accomplished 3 above states
// Perhaps single enum?
type IslandBodyProps = {
  $isScrollable?: boolean;
  $preventScroll?: boolean;
  $fullHeight?: boolean;
};

export const IslandBody = styled(IslandSectionContainer).attrs({
  gap: 'medium',
})<IslandBodyProps>`
  ${({ $isScrollable, $preventScroll }) =>
    ($isScrollable &&
      css`
        max-height: 100%;
        overflow-y: auto;
      `) ||
    ($preventScroll &&
      css`
        max-height: 100%;
        overflow-y: hidden;
      `)}

  ${({ $fullHeight }) =>
    $fullHeight &&
    css`
      flex-grow: 1;
    `}
`;
